<template>
  <div class="star">
    <div class="star-top">
      <div class="star-last">昨天</div>
      <div class="star-more" @click="goHealth">查看更多</div>
    </div>

    <div class="star-content">
      <div class="star-left">
        <img src="../../../assets/icon_notice.png" alt="" />
        <div class="star-desc">
          当前有几位长者有呼吸和睡眠的问题，可以多跟TA们聊聊天，看看是不是需要更多的帮助
        </div>
      </div>
      <div class="star-right">
        <a-carousel
          arrows
          ref="starCarousel"
          :autoplaySpeed="13000"
          :speed="1500"
          :dots="false"
          :autoplay="true"
        >
          <div v-for="(i, index) in starData.length" :key="index">
            <div
              class="star-li imgDiv"
              v-for="item in starData[i - 1]"
              :key="item.id"
            >
              <div class="star-bed">{{ item.bedName }}</div>
              <div class="star-d">
                <div v-if="item.fallIndex != 0">
                  跌倒风险指数：{{ item.fallIndex }}
                  <img
                    src="../../../assets/icon_GoUp.png"
                    v-if="item.fallIsRise == 1"
                    alt=""
                  />
                  <img
                    src="../../../assets/icon_GoDown.png"
                    v-if="item.fallIsRise == -1"
                    alt=""
                  />
                  <img
                    src="../../../assets/icon_keep.png"
                    v-if="item.fallIsRise == 0"
                    alt=""
                  />
                </div>
                <div v-else>
                  跌倒风险指数：--
                </div>
              </div>
              <div class="star-h">
                <div v-if="item.vitalityIndex != 0">
                  活力值：{{ item.vitalityIndex }}
                  <img
                    src="../../../assets/icon_GoUp.png"
                    v-if="item.vitalityIsRise == 1"
                    alt=""
                  />
                  <img
                    src="../../../assets/icon_GoDown.png"
                    v-if="item.vitalityIsRise == -1"
                    alt=""
                  />
                  <img
                    src="../../../assets/icon_keep.png"
                    v-if="item.vitalityIsRise == 0"
                    alt=""
                  />
                </div>
                <div v-else>
                  活力值：--
                </div>
              </div>
              <div class="star-q">
                <div v-if="item.moraleIndex != 0">
                  情绪值：{{ item.moraleIndex }}
                  <img
                    src="../../../assets/icon_GoUp.png"
                    v-if="item.moraleIsRise == 1"
                    alt=""
                  />
                  <img
                    src="../../../assets/icon_GoDown.png"
                    v-if="item.moraleIsRise == -1"
                    alt=""
                  />
                  <img
                    src="../../../assets/icon_keep.png"
                    v-if="item.moraleIsRise == 0"
                    alt=""
                  />
                </div>
                <div v-else>
                  情绪值：--
                </div>
              </div>

              <div class="comment-div">
                <div :title="item.healthStatusComment">
                  {{ item.healthStatusComment }}
                </div>
              </div>
              <div
                class="star-check"
                @click="details(item.bedId, item.bedName, item.sn)"
                v-if="healthBigData && healthBigData[0].enable == 1"
              >
                查看完整报告
              </div>
              <div class="star-score">
                <div class="score">{{ item.score }}</div>
                <div class="score-title">睡眠得分</div>
              </div>
            </div>
          </div>
        </a-carousel>
        <div v-show="starData.length > 1">
          <div class="left-btn">
            <img src="../../../assets/flipLeft.png" @click="pre" alt="" />
          </div>
          <div class="right-btn">
            <img src="../../../assets/flipRight.png" @click="next" alt="" />
          </div>
        </div>
        <div
          class="show-empty"
          v-show="starData.length == 0 && !starEmpty && timeStatus"
        >
          暂时无人上榜哦
        </div>
        <div class="show-empty" v-show="starEmpty && timeStatus">
          暂无内容，开发小哥哥正在排查问题，稍后再来查看吧
        </div>
        <div class="show-empty" v-show="!timeStatus">
          报告数据正在统计中，请您今天9点以后再来查看哦～
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from './Swiper';
export default {
  props: {
    healthBigData: null,
  },
  components: { Swiper },
  data() {
    return {
      ceshi: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      ceshiIndex: 4,
      // showData: [],
      starShowData: [],
      starData: [],
      starEmpty: false,
      animate: false,
      setInTime: '', // 定时器
      pageNum: 1,
      total: 1,
      getHours: null,
      timeStatus: false,
      activeDates: [],
    };
  },
  created() {},
  destroyed() {
    clearInterval(this.setInTime); // 页面销毁时清除定时器
  },
  mounted() {
    this.getData(1);
    this.getActiveDates();
  },
  methods: {
    getActiveDates() {
      var day = new Date();
      var time = day.getTime();
      for (var i = 0; i <= 29; i++) {
        var ms = 24 * 3600 * 1000 * i;
        day.setTime(parseInt(time - ms));
        var y = day.getFullYear().toString();
        var m = (day.getMonth() + 1).toString();
        if (m.length <= 1) m = '0' + m;
        var d = day.getDate().toString();
        if (d.length <= 1) d = '0' + d;
        this.activeDates[i] = y + '-' + m + '-' + d;
      }
      //console.log(this.activeDates);
    },
    pre() {
      //this.pageNum -= 1;
      //this.getData(this.pageNum);
      this.$refs.starCarousel.prev();
    },
    next() {
      //this.pageNum += 1;
      //this.getData(this.pageNum);
      this.$refs.starCarousel.next();
    },
    details(bedId, bedName, sn) {
      var scope = {
        bedId: bedId,
        bedName: bedName,
        activeType: 1,
        activeDate: this.activeDates[0],
        sn: sn,
      };
      this.$parent.details(scope);
    },
    goHealth() {
      this.$parent.tabClick2(2);
    },
    getData(num) {
      var params = {
        orderType: '',
        pageNum: num,
        pageSize: 8,
      };
      var md = new Date();
      this.getHours = md.getHours();
      if (parseInt(this.getHours) >= 9) this.timeStatus = true;
      if (this.timeStatus) {
        this.$post(
          '/api/deanData/getRotationTopList',
          params,
          (res) => {
            if (res.code == 0) {
              if (res.data && res.data.records) {
                this.$refs.starCarousel.goTo(0, true);
                for (var i = 0; i < res.data.records.length; i++) {
                  if (res.data.records[i].score <= 65)
                    this.starShowData.push(res.data.records[i]);
                }
                if (this.starShowData.length >= 4) {
                  for (
                    var i = 0;
                    i <= Math.floor(this.starShowData.length / 4) * 4;
                    i += 4
                  ) {
                    this.starData.push(this.starShowData.slice(i, i + 4));
                  }
                }
                if (this.starShowData.length % 4 != 0) {
                  var p = Math.floor(this.starShowData.length / 4) * 4;
                  this.starData.push(
                    this.starShowData.slice(
                      p,
                      p + (this.starShowData.length % 4)
                    )
                  );
                }

                this.total = res.data.total / 4;
                //console.log(this.total);
                //this.$refs.swiper.move("imgBox");
              } else {
                this.starEmpty = true;
              }
            } else {
            }
          },
          (err) => {
            // this.$message.error("提交失败！请重试！！！");

            console.log(err);
          }
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// .ant-carousel >>> .slick-slide {
//   text-align: center;
//   height: 160px;
//   line-height: 160px;
//   // background: #364d79;
//   overflow: hidden;
// }

// .ant-carousel >>> .custom-slick-arrow {
//   width: 25px;
//   height: 25px;
//   font-size: 25px;
//   color: #fff;
//   background-color: rgba(31, 45, 61, 0.11);
//   opacity: 0.3;
// }
// .ant-carousel >>> .custom-slick-arrow:before {
//   display: none;
// }
// .ant-carousel >>> .custom-slick-arrow:hover {
//   opacity: 0.5;
// }

// .ant-carousel >>> .slick-slide h3 {
//   color: #fff;
// }
.star {
  width: 100%;
  height: 274px;
  margin-top: 10px;
  // display: flex;
  // flex-direction: row;
  // align-items: center;
  // justify-content: flex-start;
  background: #ffffff;
  box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
  border-radius: 8px;

  @keyframes fadeInRight {
    from {
      opacity: 0;
      -webkit-transform: translate(0px, 0);
      transform: stranslate(0px, 0);
    }
    to {
      opacity: 1;
      -webkit-transform: translate(0px, 0);
      transform: stranslate(0px, 0);
    }
  }

  @-webkit-keyframes fadeInRight {
    from {
      opacity: 0;
      -webkit-transform: translate(0px, 0);
      transform: stranslate(0px, 0);
    }
    to {
      opacity: 1;
      -webkit-transform: translate(0px, 0);
      transform: stranslate(0px, 0);
    }
  }

  .show-empty {
    text-align: center;
    color: #8c8c8c;
    line-height: 20px;
    font-size: 16px;
    margin-top: 80px;
  }

  .star-top {
    width: 100%;
    height: 30px;
    .star-last {
      color: #8c8c8c;
      line-height: 12px;
      font-size: 10px;
      float: left;
      margin: 10px 0 0 10px;
    }
    .star-more {
      float: right;
      color: #1890ff;
      line-height: 18px;
      font-size: 12px;
      margin: 10px 10px 0 10px;
      cursor: pointer;
      position: relative;
      z-index: 9999;
    }
  }
  .star-content {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    .star-left {
      width: 250px;
      height: 200px;
      display: inline-block;
      position: relative;
      img {
        width: 90px;
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 1;
      }
      .star-desc {
        display: inline-block;
        width: 170px;
        margin: 60px 0 0 50px;
        z-index: 10;
        position: relative;
        color: #262626;
        line-height: 24px;
        font-size: 16px;
      }
    }
    .star-right {
      width: 900px;
      height: 250px;
      margin-left: 30px;
      display: inline-block;
      position: relative;
      .star-li {
        width: 210px;
        height: 215px;
        background: #ffffff;
        box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
        border-radius: 8px;
        border: 1px solid #f0f0f0;
        margin-top: 10px;
        position: relative;
        // display: inline-block;
        margin-left: 10px;
        // animation-duration: 1s !important;
        // -webkit-animation-duration: 1s !important;
        // animation-fill-mode: both !important;
        // -webkit-animation-fill-mode: both !important;
        // animation-name: fadeInRight;
        // -webkit-animation: fadeInRight;
        float: left;
        // -webkit-animation-name: fadeIn; /*动画名称*/
        // -webkit-animation-duration: 1s; /*动画持续时间*/
        // -webkit-animation-iteration-count: 1; /*动画次数*/
        // -webkit-animation-delay: 0s; /*延迟时间*/
        // animation: lToR 1s;
        // -moz-animation: lToR 1s; /* Firefox */
        // -webkit-animation: lToR 1s; /* Safari and Chrome */
        // -o-animation: lToR 1s; /* Opera */

        .star-score {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 62px;
          height: 62px;
          border-radius: 31px;
          border: 3px solid #1890ff;
          text-align: center;
          .score {
            font-size: 22px;
            color: #262626;
            line-height: 24px;
            margin-top: 8px;
          }
          .score-title {
            font-size: 10px;
            color: #8c8c8c;
            line-height: 12px;
          }
        }
        .star-bed {
          overflow: hidden;
          text-overflow: ellipsis; //显示省略号
          display: -webkit-box;
          -webkit-line-clamp: 2; //块元素显示的文本行数
          -webkit-box-orient: vertical;
          // white-space: nowrap;
          width: 120px;
          margin-left: 10px;
          margin-top: 20px;
          color: #262626;
          line-height: 18px;
          font-size: 14px;
          height: 40px;
        }
        .star-h {
          color: #262626;
          line-height: 20px;
          font-size: 14px;
          display: inline-block;
          margin-left: 10px;
          margin-top: 5px;
        }
        .star-q {
          color: #262626;
          line-height: 20px;
          font-size: 14px;
          display: inline-block;
          margin-left: 10px;
          margin-top: 5px;
        }
        .star-d {
          color: #262626;
          line-height: 20px;
          font-size: 14px;
          display: inline-block;
          margin-left: 10px;
          margin-top: 10px;
        }
        .star-h,
        .star-q,
        .star-d {
          img {
            width: 12px !important;
            position: relative;
            top: -2px;
            margin-left: 0px;
            display: inline-block;
          }
        }
        .star-check {
          width: 190px;
          height: 32px;
          background: #1890ff;
          border-radius: 2px;
          color: white;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          margin-left: 10px;
          margin-top: 10px;
          margin-bottom: 10px;
          cursor: pointer;
          position: absolute; //保证按钮一直在底部，如要自适应，去掉下面三行
          left: 0px;
          bottom: 0px;
        }
        .comment-div {
          text-align: left;
          div {
            width: 190px;
            margin-left: 10px;
            margin-top: 5px;
            overflow: hidden;
            text-overflow: ellipsis; //显示省略号
            display: -webkit-box;
            -webkit-line-clamp: 2; //块元素显示的文本行数
            -webkit-box-orient: vertical;
            color: #262626;
          }
        }
      }
      .left-btn {
        position: absolute;
        top: 70px;
        left: -18px;
        z-index: 10;
        width: 55px;
        height: 55px;
        display: inline-block;
        img {
          width: 0px;
        }
      }
      .left-btn:hover {
        img {
          width: 55px;
          cursor: pointer;
        }
      }

      .right-btn {
        position: absolute;
        top: 70px;
        right: -5px;
        z-index: 10;
        width: 55px;
        height: 55px;
        display: inline-block;
        img {
          width: 0px;
        }
      }
      .right-btn:hover {
        img {
          width: 55px;
          cursor: pointer;
        }
      }
    }
    .star-right:hover {
      .left-btn {
        img {
          width: 55px;
          cursor: pointer;
        }
      }
      .right-btn {
        img {
          width: 55px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
